export const base64ToBlob = (base64: string, contentType = '', sliceSize = 512) => {
  try {
    const byteCharacters = atob(base64)
    const byteArrays = []

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize)

      const byteNumbers = new Array(slice.length)
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i)
      }

      const byteArray = new Uint8Array(byteNumbers)
      byteArrays.push(byteArray)
    }

    const blob = new Blob(byteArrays, { type: contentType })

    return blob
  } catch (error) {
    console.error('Failed to convert base64 to Blob', error)

    return null
  }
}

export const base64ToFile = (
  base64String: string,
  fileName: string,
  mimeType: string
): File | null => {
  try {
    // Decode the base64 string
    const binaryString = atob(base64String)

    // Convert binary string to a Uint8Array
    const uint8Array = new Uint8Array(binaryString.length)
    for (let i = 0; i < binaryString.length; i++) {
      uint8Array[i] = binaryString.charCodeAt(i)
    }

    // Create a Blob from the Uint8Array
    const blob = new Blob([uint8Array], { type: mimeType })

    // Create and return a File object
    return new File([blob], fileName, { type: mimeType })
  } catch (error) {
    console.error('Failed to convert base64 string to File:', error)
    return null
  }
}

export const inferImageName = (fileType: string) => `image.${fileType.replace('image/', '')}`
export const inferVideoName = (videoFormat: string) => `video.${String(videoFormat).split('/')[1]}`
